import { render, staticRenderFns } from "./skill-lesson-record.vue?vue&type=template&id=05e6cd58"
import script from "./skill-lesson-record.vue?vue&type=script&lang=js"
export * from "./skill-lesson-record.vue?vue&type=script&lang=js"
import style0 from "./skill-lesson-record.vue?vue&type=style&index=0&id=05e6cd58&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports